import { render, staticRenderFns } from "./PasswordSetting.vue?vue&type=template&id=785a7180&scoped=true"
import script from "./PasswordSetting.vue?vue&type=script&lang=ts"
export * from "./PasswordSetting.vue?vue&type=script&lang=ts"
import style0 from "./PasswordSetting.vue?vue&type=style&index=0&id=785a7180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785a7180",
  null
  
)

export default component.exports